module.exports = __webpack_public_path__ + "img/zuijia_27.36198c64.png";